"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const radio = {
    MuiRadio: {
        styleOverrides: {
            root: {
                "& .MuiSvgIcon-root": {
                    fill: colors_1.default.primary[900],
                },
                "&.Mui-disabled": {
                    "& .MuiSvgIcon-root": {
                        fill: colors_1.default.primary[600],
                    },
                },
            },
        },
    },
};
exports.default = radio;
